import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import type { Person } from "../../../../utils/backend-types";
import type { ColumnDefinitionProps } from "./columns.types";

interface PersonColumnProps<
  T extends MRT_RowData
> extends ColumnDefinitionProps<T> {
  persons: Array<Pick<Person, "id" | "name">>;
}

function getPersonColumn<T extends MRT_RowData>({
  key,
  options,
  persons
}: PersonColumnProps<T>): MRT_ColumnDef<T> {
  /**
   * Note: The term 'person' in this context can refer to an operator, person, supplier, or company
   * depending on the context in which this column is used.
   */
  return {
    header: "Gesellschaft",
    accessorKey: key,
    accessorFn: (row) =>
      persons?.find((person) => person.id === row[key])?.name || "",
    filterVariant: "multi-select",
    ...options
  };
}

export { getPersonColumn };
